import styled from 'styled-components';

export const gradientGimmick = ({width}) => `
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    height: var(--gradient-gimmick-bar-height);
    background-image: linear-gradient(to right, var(--color-gradient-100));
    width: ${width || '100%'};
`;

export const GradientGimmickBar = styled.div`
    ${gradientGimmick};
`;
